// extracted by mini-css-extract-plugin
export default {"layout":"main_layout__jazOF","container":"main_container__l047c","logo":"main_logo__xdsk5","link":"main_link__FM7Wa"};